import { render, staticRenderFns } from "./ScoreRecord.vue?vue&type=template&id=6501599b&scoped=true"
import script from "./ScoreRecord.vue?vue&type=script&lang=js"
export * from "./ScoreRecord.vue?vue&type=script&lang=js"
import style0 from "./ScoreRecord.vue?vue&type=style&index=0&id=6501599b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501599b",
  null
  
)

export default component.exports